import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function AntiTerror() {
  const [articles, setArticles] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const contentRefs = useRef({});
  const articleRefs = useRef({});
  const location = useLocation();

  useEffect(() => {
    fetch("/data/anti_terror.json")
      .then((res) => res.json())
      .then((data) => setArticles(data.reverse()));
  }, []);

  // Скролл и подсветка по hash
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = articleRefs.current[id];
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          el.classList.add("highlight");

          setTimeout(() => {
            el.classList.add("fade-out"); // плавное исчезновение
            setTimeout(() => {
              el.classList.remove("highlight", "fade-out"); // полностью убираем классы
            }, 500);
          }, 500);
        }, 150);
      }
    }
  }, [location, articles]);

  const toggleArticle = (id) => {
    const el = contentRefs.current[id];
    if (!el) return;

    if (expandedId === id) {
      const fullHeight = el.scrollHeight;
      el.style.height = `${fullHeight}px`;
      requestAnimationFrame(() => {
        el.style.transition = "height 1.5s ease";
        el.style.height = "0px";
      });
      setTimeout(() => {
        el.style.transition = "";
        setExpandedId(null);
      }, 1500);
    } else {
      setExpandedId(id);
      requestAnimationFrame(() => {
        const fullHeight = el.scrollHeight;
        el.style.height = "0px";
        requestAnimationFrame(() => {
          el.style.transition = "height 1.5s ease";
          el.style.height = `${fullHeight}px`;
        });
      });
    }
  };

  return (
    <section className="licenses antiCorruption">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Антитеррористическая безопасность
      </h1>

      <div className="allnews__news">
        {articles.map((article) => {
          const isExpanded = expandedId === article.id;
          const paragraphs = article.content_text.split("\n\n");
          const preview = paragraphs[0];
          const restText = paragraphs.slice(1);
          let dashCounter = 0;
          const url = article.url;

          return (
            <div
              key={article.id}
              ref={(el) => (articleRefs.current[article.id] = el)}
              id={article.id}
              className="allnews__blank"
            >
              <p className="allnews__date">{article.date}</p>
              <div className="allnews__photo">
                <img
                  className="allnews__img"
                  src={article.localImg}
                  alt={article.title}
                />
              </div>

              <h4 className="allnews__title">{article.title}</h4>

              <p className="allnews__text">{preview}</p>
              {url && url.includes("vk.com") && (
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contacts__table-tel"
                >
                  Смотреть видео
                </a>
              )}

              <div
                className="allnews__text-all"
                ref={(el) => (contentRefs.current[article.id] = el)}
                style={{
                  height: isExpanded
                    ? `${contentRefs.current[article.id]?.scrollHeight}px`
                    : "0px",
                  overflow: "hidden",
                }}
              >
                {restText.map((p, idx) => {
                  const trimmed = p.trim();

                  if (/^[-–—]/.test(trimmed)) {
                    dashCounter++;
                    if (dashCounter % 2 === 1) {
                      return (
                        <p className="allnews__text" key={idx}>
                          <b>{trimmed}</b>
                        </p>
                      );
                    } else {
                      return (
                        <p className="allnews__text" key={idx}>
                          {trimmed}
                        </p>
                      );
                    }
                  }

                  return (
                    <p className="allnews__text" key={idx}>
                      {trimmed}
                    </p>
                  );
                })}
                {isExpanded && (
                  <p className="allnews__author">{article.author}</p>
                )}
              </div>

              <div className="allnews__blank-link">
                <button
                  onClick={() => toggleArticle(article.id)}
                  className="prevention__button news__button licenses__toggle-btn"
                >
                  {isExpanded ? "Скрыть" : "Подробнее"}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
